// Generate the config at build time, so that Tailwind dependencies are not included in the bundle (Source: https://tailwindcss.com/docs/configuration#referencing-in-java-script)
const config = preval`
    // Clear cache - Count: 1 <--- Increase this number to break the cache
    const resolveConfig = require('tailwindcss/resolveConfig')
    const tailwindConfig = require('../../../tailwind.config.js')

    module.exports = resolveConfig(tailwindConfig)
`

export const colors = config.theme.colors
export const breakpoints = config.theme.screens

export const blockCategories = [
    {
        key: 'text',
        label: 'Text inputs',
    },
    {
        key: 'number',
        label: 'Number inputs',
    },
    {
        key: 'select',
        label: 'Select inputs',
    },
    {
        key: 'content',
        label: 'Content',
    },
    {
        key: 'other',
        label: 'Misc. inputs',
    },
]

export const answerableBlockTypes = [
    'text',
    'name',
    'email',
    'textarea',
    'radios',
    'checkboxes',
    'hidden',
    'scale',
    'number',
    'currency',
    'percent',
    'url',
    'file-upload',
    'confirm',
    'dropdown',
    'phone',
    'phone-v2',
    'select-one-image',
]

export const optionBlockTypes = [
    'radios',
    'checkboxes',
    'dropdown',
    'select-one-image',
]

export const contentBlockTypes = [
    'h1',
    'h2',
    'paragraph',
    'rich-text',
    'image',
    'embed',
]

export const placeholderBlockTypes = answerableBlockTypes.filter(
    type =>
        ![
            'file-upload',
            'scale',
            'hidden',
            'checkboxes',
            'radios',
            'confirm',
            'select-one-image',
        ].includes(type)
)

export const blockTypes = [
    {
        type: 'h1',
        label: 'Heading 1',
        icon: 'H1',
        category: 'content',
        className: 'heading-1',
    },
    {
        type: 'h2',
        label: 'Heading 2',
        icon: 'H2',
        category: 'content',
        className: 'heading-2',
    },
    {
        type: 'rich-text',
        label: 'Text',
        icon: 'Paragraph',
        category: 'content',
        className: 'rich-text',
    },
    {
        type: 'image',
        label: 'Image',
        icon: 'Image',
        category: 'content',
        className: 'image',
    },
    {
        type: 'embed',
        label: 'Embed',
        icon: 'Embed',
        category: 'content',
        className: 'embed',
    },
    {
        type: 'calendly-embed',
        label: 'Calendly Embed',
        icon: 'Calendly',
        category: 'content',
        className: 'calendly-embed',
    },
    {
        type: 'hubspot-calendar-embed',
        label: 'HubSpot calendar embed',
        icon: 'HubSpot',
        category: 'content',
        className: 'hubspot-calendar-embed',
    },
    {
        type: 'name',
        label: 'Name',
        icon: 'Name',
        category: 'text',
        className: 'name',
    },
    {
        type: 'email',
        label: 'Email',
        icon: 'Email',
        category: 'text',
        className: 'email',
    },
    {
        type: 'phone-v2',
        label: 'Phone',
        icon: 'Phone',
        category: 'text',
        className: 'phone',
    },
    {
        type: 'url',
        label: 'URL',
        icon: 'Anchor',
        category: 'text',
        className: 'url',
    },
    {
        type: 'text',
        label: 'Short text',
        icon: 'ShortText',
        category: 'text',
        className: 'short-text',
    },
    {
        type: 'textarea',
        label: 'Long text',
        icon: 'LongText',
        category: 'text',
        className: 'long-text',
    },
    {
        type: 'number',
        label: 'Number',
        icon: 'Numeric',
        category: 'number',
        className: 'number',
    },
    {
        type: 'currency',
        label: 'Currency',
        icon: 'Currency',
        category: 'number',
        className: 'currency',
    },
    {
        type: 'percent',
        label: 'Percent',
        icon: 'Percent',
        category: 'number',
        className: 'percent',
    },
    {
        type: 'confirm',
        label: 'Checkbox',
        icon: 'Confirm',
        category: 'select',
        className: 'checkbox',
    },
    // {
    //     type: 'dropdown',
    //     label: 'Dropdown',
    //     icon: 'Dropdown',
    //     category: 'select',
    //     className: 'dropdown',
    // },
    {
        type: 'radios',
        label: 'Select one',
        icon: 'Radio',
        category: 'select',
        className: 'select-one',
    },
    {
        type: 'checkboxes',
        label: 'Select multiple',
        icon: 'Checkbox',
        category: 'select',
        className: 'select-multiple',
    },
    {
        type: 'scale',
        label: 'Scale (0-10)',
        icon: 'Scale',
        category: 'select',
        className: 'scale',
    },
    {
        type: 'hidden',
        label: 'Hidden',
        icon: 'Hidden',
        category: 'other',
        className: 'hidden',
    },
    {
        type: 'file-upload',
        label: 'File upload',
        icon: 'Upload',
        category: 'other',
        beta: true,
        gate: {
            feature: 'file uploads',
            plan: 'Pro',
        },
        className: 'file-upload',
    },
]

export const defaultBlocks = {
    h1: {
        type: 'h1',
        content: '',
    },
    h2: {
        type: 'h2',
        content: '',
    },
    'rich-text': {
        type: 'rich-text',
        content: '',
    },
    image: {
        type: 'image',
        url: '/images/image-block.jpg',
        alt: '',
    },
    embed: {
        type: 'embed',
        url: '',
    },
    'calendly-embed': {
        type: 'calendly-embed',
        url: '',
    },
    'hubspot-calendar-embed': {
        type: 'hubspot-calendar-embed',
        url: '',
    },
    name: {
        type: 'name',
        label: "What's your name?",
        placeholder: 'Jane Smith',
        required: true,
    },
    email: {
        type: 'email',
        label: "What's your email?",
        placeholder: 'jane@example.com',
        required: true,
        block_free_providers: false,
    },
    'phone-v2': {
        type: 'phone-v2',
        label: "What's your phone number?",
        placeholder: '(111) 222-3333',
        required: true,
        default_country: 'us',
        allow_multiple_countries: true,
    },
    text: {
        type: 'text',
        label: '',
        placeholder: '',
        required: true,
    },
    textarea: {
        type: 'textarea',
        label: '',
        placeholder: '',
        required: true,
    },
    number: {
        type: 'number',
        label: '',
        placeholder: '',
        min: null,
        max: null,
        required: true,
    },
    percent: {
        type: 'percent',
        label: '',
        placeholder: '50%',
        min: 0,
        max: 100,
        required: true,
    },
    currency: {
        type: 'currency',
        label: '',
        placeholder: '1,000.00',
        currency: 'generic_dollar',
        required: true,
        min: null,
        max: null,
    },
    url: {
        type: 'url',
        label: '',
        placeholder: '',
        required: true,
    },
    hidden: {
        type: 'hidden',
        label: '',
        required: false,
    },
    radios: {
        type: 'radios',
        label: '',
        required: true,
        options: [],
        hasCustomOption: false,
        customOptionLabel: 'Other',
        customOptionPlaceholder: 'Please expand on your choice',
    },
    'select-one-image': {
        type: 'select-one-image',
        label: '',
        required: true,
        hide_labels: false,
        options: [],
    },
    dropdown: {
        type: 'dropdown',
        label: '',
        placeholder: 'Select an option',
        required: true,
        options: [],
    },
    checkboxes: {
        type: 'checkboxes',
        label: '',
        required: true,
        options: [],
    },
    scale: {
        type: 'scale',
        label: '',
        required: true,
        from_label: '',
        center_label: '',
        to_label: '',
        min: 0,
        max: 10,
    },
    'file-upload': {
        type: 'file-upload',
        label: '',
        required: true,
    },
    confirm: {
        type: 'confirm',
        label: '',
        required: true,
        content: '',
    },
}

export const defaultSkipIfBlock = {
    blockId: null,
    operator: 'answer_equals',
    value: '',
}

export const integrationsDirectory = [
    {
        type: 'hubspot',
        title: 'HubSpot',
        description: '<p>Add contacts to HubSpot.</p>',
        feature_flag: 'hubspot integration',
        has_feature_flag: {
            label: {
                color: 'green',
                text: 'New',
            },
        },
        missing_feature_flag: {
            coming_soon: {
                cta: "Upgrade to 'Pro'",
                href: '/billing/edit',
                reform_email_field_id: '120b422e-8a22-4779-9853-23657f153337',
            },
        },
    },
    {
        type: 'email',
        title: 'Email notifications',
        description:
            "<p>Receive an email every time there's a new submission of your form.</p>",
    },
    {
        type: 'email_automation',
        title: 'Email automation',
        description:
            '<p>Configure automated emails to go out after your form has been submitted.</p>',
    },
    {
        type: 'receipt',
        title: 'Receipts',
        description:
            '<p>Send an email to respondents with a receipt of their form submission.</p>',
    },
    {
        type: 'webhook',
        title: 'Webhooks',
        description:
            "<p>Configure webhooks to be triggered every time there's a submission of your form. <a href='https://docs.reform.app/article/7-webhooks' target='_blank'>Learn more.</a></p>",
    },
    {
        type: 'recaptcha',
        title: 'reCAPTCHA',
        description:
            '<p>Reduce spam by analyzing users before they submit a form.</p>',
    },
    {
        type: 'google_tag_manager',
        title: 'Google Tag Manager',
        description:
            '<p>Automatically capture form events in the datalayer.</p>',
    },
    {
        type: 'google_analytics_4',
        title: 'Google Analytics 4',
        description:
            '<p>Automatically send form events to Google Analytics 4.</p>',
    },
    {
        type: 'exact_buyer',
        title: 'ExactBuyer',
        description: '<p>Enrich and shorten your forms.</p>',
        feature_flag: 'exact_buyer integration',
        has_feature_flag: {
            label: {
                color: 'green',
                text: 'New',
            },
        },
        missing_feature_flag: {
            label: {
                color: 'blue',
                text: 'Beta',
            },
            cta: 'Coming soon',
        },
    },
    {
        type: 'zapier',
        title: 'Zapier',
        external: {
            cta: 'Go to Zapier',
            href: 'https://zapier.com/apps/reform/integrations',
        },
        description: '<p>Connect Reform to Zapier and the rest of the World.',
    },
    {
        type: 'google_sheets',
        title: 'Google Sheets',
        description: '<p>Add new submissions to a row in Google Sheets.</p>',
        zapier: {
            url: 'https://zapier.com/apps/reform/integrations/google-sheets',
        },
    },
    {
        type: 'slack',
        title: 'Slack',
        description:
            "<p>Post a message in Slack when there's a new submission.</p>",
        zapier: {
            url: 'https://zapier.com/apps/reform/integrations/slack',
        },
    },
    {
        type: 'notion',
        title: 'Notion',
        label: {
            color: 'blue',
            text: 'Beta',
        },
        description: '<p>Add new submissions to a Notion database.</p>',
        zapier: {
            url: 'https://zapier.com/apps/reform/integrations/notion',
        },
    },
    {
        type: 'convert_kit',
        title: 'ConvertKit',
        label: {
            color: 'blue',
            text: 'Beta',
        },
        description: '<p>Add responses as subscribers in ConvertKit</p>',
        zapier: {
            url: 'https://zapier.com/apps/reform/integrations/convertkit',
        },
    },
    {
        type: 'close',
        title: 'Close',
        label: {
            color: 'blue',
            text: 'Beta',
        },
        description: '<p>Sync responses with leads in Close.</p>',
    },
    {
        type: 'less_annoying',
        title: 'Less Annoying CRM',
        label: {
            color: 'blue',
            text: 'Beta',
        },
        description: '<p>Add contacts to Less Annoying CRM</p>',
    },
    {
        type: 'fathom',
        title: 'Fathom Analytics',
        description: '<p>Privacy-first analytics for your reforms.</p>',
    },
    {
        type: 'airtable',
        title: 'Airtable',
        label: {
            color: 'yellow',
            text: 'Coming soon',
        },
        coming_soon: {
            cta: 'Join waitlist',
            href: 'https://forms.reform.app/reform/airtable-ea',
            reform_email_field_id: 'c75e433c-f94f-4e10-a04f-fcd77f37500f',
        },
        description: '<p>Add new submissions to an Airtable database.</p>',
        zapier: {
            url: 'https://zapier.com/apps/reform/integrations/airtable',
        },
    },
    {
        type: 'mailchimp',
        title: 'Mailchimp',
        label: {
            color: 'yellow',
            text: 'Coming soon',
        },
        coming_soon: {
            cta: 'Join waitlist',
            href: 'https://forms.reform.app/reform/mailchimp-ea',
            reform_email_field_id: '5f52ea80-463c-4b7e-be65-a60765f94d72',
        },
        description: '<p>Add responses as subscribers in Mailchimp</p>',
        zapier: {
            url: 'https://zapier.com/apps/reform/integrations/mailchimp',
        },
    },
    {
        type: 'request',
        title: 'Need something else?',
        coming_soon: {
            cta: 'Let us know',
            href: 'https://forms.reform.app/reform/request-for-integration',
            reform_email_field_id: '236044aa-4d1a-4b8e-94b3-0ef0efdc21fb',
        },
        description:
            "<p>Is there an integration you'd love to see in Reform?</p>",
    },
]

export const maxFileUploadSize = 10485760 // 10mb

export const currencies = [
    {
        label: 'Dollars',
        value: 'generic_dollar',
    },
    {
        label: 'US dollars',
        value: 'usd',
    },
    {
        label: 'Canadian dollars',
        value: 'cad',
    },
    {
        label: 'Australian dollars',
        value: 'aud',
    },
    {
        label: 'Euro',
        value: 'eur',
    },
    {
        label: 'British pounds',
        value: 'gbp',
    },
]

export const currencyMap = {
    generic_dollar: {
        label: 'Dollars',
        before: '$',
        after: '',
    },
    usd: {
        label: 'US dollars',
        before: '$',
        after: 'USD',
    },
    aud: {
        label: 'Australian dollars',
        before: '$',
        after: 'AUD',
    },
    cad: {
        label: 'Canadian dollars',
        before: '$',
        after: 'CAD',
    },
    eur: {
        label: 'Euro',
        before: '€',
        after: 'EUR',
    },
    gbp: {
        label: 'British pounds',
        before: '£',
        after: 'GBP',
    },
}
